module.exports = __webpack_public_path__ + "static/img/home_spec_col_2.4ac33b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_spec_col_2.jpg
// module id = GP9y
// module chunks = 0